export const MIN_PASSWORD_LEN = 9;

export const PASSWORD_RULES = [
  { id: "len", label: `At least ${MIN_PASSWORD_LEN} characters`, test: (p) => String(p || "").length >= MIN_PASSWORD_LEN },
  { id: "upper", label: "One uppercase letter (A–Z)", test: (p) => /[A-Z]/.test(p || "") },
  { id: "lower", label: "One lowercase letter (a–z)", test: (p) => /[a-z]/.test(p || "") },
  { id: "num", label: "One number (0–9)", test: (p) => /[0-9]/.test(p || "") },
];

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email) {
  return EMAIL_RE.test(String(email || "").trim());
}

export function passwordChecks(password) {
  return PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(password) }));
}

export function passwordIsStrong(password) {
  return passwordChecks(password).every((r) => r.ok);
}

/** idle | ok | bad */
export function fieldTone({ value, touched, valid, required = true }) {
  const empty = !String(value || "").length;
  if (!touched && empty) return "idle";
  if (required && empty && touched) return "bad";
  if (!empty && valid) return "ok";
  if (touched || !empty) return valid ? "ok" : "bad";
  return "idle";
}

export function textFieldToneSx(tone, colors) {
  const map = {
    idle: colors.borderStrong,
    ok: colors.success,
    bad: colors.error,
  };
  const border = map[tone] || colors.borderStrong;
  const focus = tone === "bad" ? colors.error : colors.primary;
  return {
    mb: 0,
    "& .MuiOutlinedInput-root": {
      background: colors.surface,
      borderRadius: "8px",
      minHeight: 44,
      "& fieldset": { borderColor: border, borderWidth: 1 },
      "&:hover fieldset": { borderColor: tone === "bad" ? colors.error : colors.borderStrong },
      "&.Mui-focused": {
        background: colors.surface,
      },
      "&.Mui-focused fieldset": { borderColor: focus, borderWidth: 1.5 },
    },
    "& .MuiOutlinedInput-input": {
      py: "11px",
      fontSize: 14,
    },
    "& .MuiFormHelperText-root": {
      mx: 0,
      mt: 0.6,
      fontSize: 12,
      color: colors.muted,
    },
  };
}
